import { Bell } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { ChevronsUpDown } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { useNotifications } from "@/hooks/queries/use-notifications";
import { CustomSheet } from "./custom-sheet";
import { useNavigate } from "react-router-dom";

export function NotificationsButton() {
  const navigate = useNavigate();
  const { notifications } = useNotifications();
  return (
    <CustomSheet
      title="Notifications"
      trigger={
        <Button variant="ghost" className="relative" size="icon">
          <Bell className="h-5 w-5" />
          {notifications.length > 0 && (
            <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-red-500 text-white text-xs flex items-center justify-center">
              {notifications.length}
            </span>
          )}
        </Button>
      }
    >
      <ScrollArea className="h-[calc(100dvh-5rem)] mt-4">
        <div className="space-y-4">
          {notifications.map((notification) => (
            <div key={notification.id} className="border-b pb-4 last:border-0">
              <Collapsible>
                <CollapsibleTrigger className="w-full flex items-center justify-between">
                  <h3 className="font-medium mb-1">{notification.title}</h3>
                  <ChevronsUpDown className="h-4 w-4" />
                </CollapsibleTrigger>
                <CollapsibleContent className="flex flex-col">
                  <p className="text-sm text-muted-foreground mb-2">
                    {notification.description}
                  </p>
                  {notification.link && (
                    <Button
                      variant="ghost"
                      onClick={() =>
                        navigate(
                          `${notification.link}?id=${notification.requestId}`
                        )
                      }
                      className="text-sm text-primary self-end h-auto"
                    >
                      Go To Request
                    </Button>
                  )}
                </CollapsibleContent>
              </Collapsible>
            </div>
          ))}
        </div>
      </ScrollArea>
    </CustomSheet>
  );
}
